const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 22.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 8.8,
    width: 19,
    height: 13.97,
    rx: 2.2,
    ry: 2.2,
    style: {
      fill: "#888b8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.35,2.01c-1.24-1.25-2.96-2.01-4.85-2.01C5.71,0,2.65,3.08,2.65,6.85V15.91c0,3.79,3.07,6.85,6.85,6.85s6.85-3.07,6.85-6.85V6.85c0-1.89-.77-3.6-2-4.84Zm-1.28,13.89c0,1.97-1.6,3.57-3.57,3.57s-3.57-1.6-3.57-3.57V6.85c0-1.96,1.6-3.57,3.57-3.57s3.57,1.61,3.57,3.57V15.91Z",
    style: {
      fill: "#888b8d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.ba3ff22d74f65f98c8ac1d552b9e194a.svg";
export { ForwardRef as ReactComponent };